import React, {useState} from "react";
import {css} from "@emotion/react";
import {parseISO} from "date-fns";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {calculateRemSize, flex, flexDirection, maxWidth, mb, minWidth, onDesktop, w100} from "@pg-design/helpers-css";
import {IOption, Select} from "@pg-design/select-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {PricesViewType} from "../../helpers/prices_view_type";
import {getCitiesData} from "../../utils/get_cities_data";
import {getPricesTextFromType} from "../../utils/get_from_prices_type";
import {BarChart} from "./BarChart";

interface IProps {
    type: PricesViewType;
}

export const PricesBarChart = (props: IProps) => {
    const [selectedCity, setSelectedCity] = useState<IOption | null>(null);

    const {isMobile} = useUserDevice();
    const citiesData = getCitiesData();
    const date = parseISO(citiesData[0].date);
    const month = date && date.toLocaleString("pl-PL", {month: "long"});
    const dateLabel = month && `${month} ${date.getFullYear()}`;

    const citySelectOptions = PRICES_CITIES.reduce((acc, curr) => {
        return [...acc, {label: curr.name, value: curr.slug}];
    }, [] as IOption[]);

    const goToCityView = () => {
        if (selectedCity) {
            window.open(rpAppLink.prices.flats.city({regionSlug: selectedCity.value as string}), "_blank");
        }
        return;
    };

    return (
        <Container css={mb(8)}>
            <div css={[mb(6), onDesktop(mb(8))]}>
                <Text as="h2" variant="headline_1" align="center" css={[mb(5), onDesktop(mb(3))]}>
                    Wykres <Highlight>{`średnie ${getPricesTextFromType(props.type)} w Polsce (${dateLabel})`}</Highlight>
                </Text>

                <Text variant="body_copy_0" align={isMobile ? "center" : "left"} css={[mb(6), onDesktop(mb(3))]}>
                    Średnie ceny mieszkań aktualizujemy na początku każdego miesiąca. Dane zbieramy na podstawie 90% monitorowanych inwestycji z rynku
                    pierwotnego realizowanych w całej Polsce.
                </Text>

                <div css={selectWrapper}>
                    <Select
                        onChange={(option) => setSelectedCity(option as IOption)}
                        options={citySelectOptions}
                        placeholder="Wybierz miasto"
                        css={selectStyle}
                    />

                    <Button variant="filled_primary" size="small" onClick={goToCityView} css={minWidth("180px")}>
                        zobacz dane
                    </Button>
                </div>
            </div>

            <BarChart />
        </Container>
    );
};

const selectWrapper = css`
    ${w100};
    ${flex()};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};

    ${onDesktop(flexDirection("row"))};
`;

const selectStyle = css`
    ${w100};

    ${onDesktop(maxWidth("250px"))};
`;
import React, {useState} from "react";
import {css} from "@emotion/react";
import {parseISO} from "date-fns";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {calculateRemSize, flex, flexDirection, maxWidth, mb, minWidth, onDesktop, w100} from "@pg-design/helpers-css";
import {IOption, Select} from "@pg-design/select-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {PricesViewType} from "../../helpers/prices_view_type";
import {getCitiesData} from "../../utils/get_cities_data";
import {getPricesTextFromType} from "../../utils/get_from_prices_type";
import {BarChart} from "./BarChart";

interface IProps {
    type: PricesViewType;
}

export const PricesBarChart = (props: IProps) => {
    const [selectedCity, setSelectedCity] = useState<IOption | null>(null);

    const {isMobile} = useUserDevice();
    const citiesData = getCitiesData();
    const date = parseISO(citiesData[0].date);
    const month = date && date.toLocaleString("pl-PL", {month: "long"});
    const dateLabel = month && `${month} ${date.getFullYear()}`;

    const citySelectOptions = PRICES_CITIES.reduce((acc, curr) => {
        return [...acc, {label: curr.name, value: curr.slug}];
    }, [] as IOption[]);

    const goToCityView = () => {
        if (selectedCity) {
            window.open(rpAppLink.prices.flats.city({regionSlug: selectedCity.value as string}), "_blank");
        }
        return;
    };

    return (
        <Container css={mb(8)}>
            <div css={[mb(6), onDesktop(mb(8))]}>
                <Text as="h2" variant="headline_1" align="center" css={[mb(5), onDesktop(mb(3))]}>
                    Wykres <Highlight>{`średnie ${getPricesTextFromType(props.type)} w Polsce (${dateLabel})`}</Highlight>
                </Text>

                <Text variant="body_copy_0" align={isMobile ? "center" : "left"} css={[mb(6), onDesktop(mb(3))]}>
                    Średnie ceny mieszkań aktualizujemy na początku każdego miesiąca. Dane zbieramy na podstawie 90% monitorowanych inwestycji z rynku
                    pierwotnego realizowanych w całej Polsce.
                </Text>

                <div css={selectWrapper}>
                    <Select
                        onChange={(option) => setSelectedCity(option as IOption)}
                        options={citySelectOptions}
                        placeholder="Wybierz miasto"
                        css={selectStyle}
                    />

                    <Button variant="filled_primary" size="small" onClick={goToCityView} css={minWidth("180px")}>
                        zobacz dane
                    </Button>
                </div>
            </div>

            <BarChart />
        </Container>
    );
};

const selectWrapper = css`
    ${w100};
    ${flex()};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};

    ${onDesktop(flexDirection("row"))};
`;

const selectStyle = css`
    ${w100};

    ${onDesktop(maxWidth("250px"))};
`;
